export const version = "solidity/5.7.0";
//# sourceMappingURL=_version.js.map